import { Helmet } from 'react-helmet-async';

const SITE_URL = 'https://kommunaleavgifter.no';
const DEFAULT_IMAGE = `${SITE_URL}/opengraph-image.png`;

interface SeoProps {
  title: string;
  description: string;
  path?: string;
  image?: string;
  imageAlt?: string;
  noindex?: boolean;
}

/** Dynamiske meta-tagger for SEO og deling på sosiale medier */
export const Seo = ({
  title,
  description,
  path = '/',
  image = DEFAULT_IMAGE,
  imageAlt = 'Kommunale avgifter i Norge – sammenlign kommuner',
  noindex = false,
}: SeoProps) => {
  const url = `${SITE_URL}${path.startsWith('/') ? path : `/${path}`}`;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}

      {/* Open Graph */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      {imageAlt && <meta property="og:image:alt" content={imageAlt} />}
      <meta property="og:locale" content="nb_NO" />

      {/* Twitter */}
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      {imageAlt && <meta name="twitter:image:alt" content={imageAlt} />}

      {/* Canonical */}
      <link rel="canonical" href={url} />
    </Helmet>
  );
};
